<template>
    <vx-input v-bind="attrs" v-on="$listeners" v-model="emailAddress" />
</template>

<script>
export default {
    name: 'vx-email-input',
    props: {
        value: {
            type: String
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        emailAddress: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        attrs() {
            return {
                name: 'email',
                icon: 'icon-mail',
                placeholder: 'Email',
                ...this.$attrs,
                rules: [...this.rules, 'email']
            }
        }
    }
}
</script>

<style></style>
